import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';

const UserAvatar = ({ user, size = 'md', className = '' }) => {
  const [imageLoadError, setImageLoadError] = useState(false);

  // --- [INICIO DE LA CORRECCIÓN] ---
  // Se usan las nuevas propiedades del objeto 'user' que vienen del backend.
  const { username, profilePictureUrl, profilePictureWebPUrl } = user || {};

  // Se resetea el estado de error si el usuario cambia (ej. al hacer login/logout)
  useEffect(() => {
    setImageLoadError(false);
  }, [profilePictureUrl, profilePictureWebPUrl]);
  // --- [FIN DE LA CORRECCIÓN] ---

  const sizeClasses = {
    sm: 'w-8 h-8 text-lg',
    md: 'w-10 h-10 text-xl',
    lg: 'w-14 h-14 text-2xl',
    xl: 'w-20 h-20 text-3xl',
  };
  const sizeClass = sizeClasses[size] || sizeClasses.md;

  const showImage =
    !imageLoadError && (profilePictureWebPUrl || profilePictureUrl);
  const initial = username ? username.charAt(0).toUpperCase() : '?';

  return (
    <div
      className={`relative rounded-full overflow-hidden flex items-center justify-center bg-neutral-200 dark:bg-neutral-700 text-neutral-500 dark:text-neutral-400 font-bold ${sizeClass} ${className} flex-shrink-0`}
    >
      {showImage ? (
        <picture>
          {profilePictureWebPUrl && (
            <source srcSet={profilePictureWebPUrl} type="image/webp" />
          )}
          {profilePictureUrl && <source srcSet={profilePictureUrl} />}
          <img
            src={profilePictureUrl}
            alt={username ? `${username} avatar` : 'User avatar'}
            className="w-full h-full object-cover"
            onError={() => setImageLoadError(true)}
          />
        </picture>
      ) : (
        <div className="flex items-center justify-center w-full h-full">
          {initial !== '?' ? (
            initial
          ) : (
            <FontAwesomeIcon icon={faUserCircle} className="text-current" />
          )}
        </div>
      )}
    </div>
  );
};

export default UserAvatar;
